import type { AdapterMeta } from "@repo/adapter-core";

export const PLACE_ESTATE_AGENTS_META: AdapterMeta = {
  slug: "place-estate-agents",
  name: "Place Estate Agents",
  baseUrl: "https://www.eplace.com.au",
  description: "Brisbane-focused premium agency with QLD sold property coverage.",
  supportedStates: ["QLD"],
  urlPattern: /eplace\.com\.au\/properties\?external_id=R2-\d+/i,
  sourceType: "agency",
};
